import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { SafetyInductionService } from '../services/safety-induction.service';
import { DialogAddAttendeeComponent } from './components/dialog-add-attendee/dialog-add-attendee.component';
import { DialogFindAttendeeComponent } from './components/dialog-find-attendee/dialog-find-attendee.component';
import { CreateNewInductionVM, GETPerfomeInductionVM, UsersVM } from './perform-induction';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { PreferencesService } from '../../preferences/preferences.service';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-perform-induction',
  templateUrl: './perform-induction.component.html',
  styleUrls: ['./perform-induction.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})
export class PerformInductionComponent implements OnInit {

  constructor(
    private _router:Router,
    private _appService: AppService,
    private _inductionService: SafetyInductionService,
    public dialog: MatDialog,
    private readonly _pref: PreferencesService,
  ) { }


  date : Date= new Date();
  dateForDisplay:string=moment().format("DD/MM/YYYY");
  // minDate: Date = new Date();
  //   maxDate: Date = new Date();
  serializedDate = new FormControl((new Date()).toISOString());
  InductionType: number=0;
  PerformInduction: GETPerfomeInductionVM;
  ArrPersonsInducted: UsersVM[];
  ArrExternalPersonsInducted: UsersVM[];
  identityServerUri:string;
  State:number=0;

  ngOnInit() {
    this._appService.setPageTitle('Induction');
    //this._appService.setPageSubTitle('');

    this._inductionService.GETPerfomeInduction().subscribe(res => {
      console.log("res", res)
      if (res.m_Item1) {
        this.PerformInduction = res.m_Item2
      }
    })

    

  }

  dateChange(){
    //this.dateForDisplay; = moment(this.date).format("DD/MM/YYYY");
  }

  changePerformInductionState(ID){

  }

  //change perform induction listview
  changePerformInductionType(ID) {
    if(!this.ArrPersonsInducted || this.ArrPersonsInducted.length <= 0){
      let user = new UsersVM();
      user.UserAuto = -1
      let arr = []
      arr.push(user)
      this.ArrPersonsInducted = arr;
    }
    
    
  }

  dateChanged(){
    console.log("Date",this.date)
  }

  //add new user to induct
  ClickAddPersonToInduct() {

    //check last person has value pr not
    let arrayLength = this.ArrPersonsInducted.length;
    if(arrayLength>0){
      let lastPos = this.ArrPersonsInducted[arrayLength-1]
      if(lastPos.UserAuto<= -1){
        return
      }

    }

    let user = new UsersVM();
    user.UserAuto = -1
    let arr = this.ArrPersonsInducted
    arr.push(user)
    this.ArrPersonsInducted = arr;
  }

  //remove user from induct list
  ClickRemovePersonFromInduct(person) {
    console.log("person",person)
    console.log("this.ArrPersonsInducted",this.ArrPersonsInducted)

    if(person.UserAuto == -1){
      return;
    }

    let arr = this.ArrPersonsInducted
    let newArr = arr.filter(a => a.UserAuto != person.UserAuto)
    this.ArrPersonsInducted = newArr;
  }

  ClickRemovePersonFromInductEx(person){
    let arr = this.ArrExternalPersonsInducted
    let newArr = arr.filter(a => a.UserAuto != person.UserAuto)
    this.ArrExternalPersonsInducted = newArr;
  }

  //change users in inducted users list
  changeInductedPerson(NewUserID, personListItem) {
    
    
      let arr = this.ArrPersonsInducted
      let selectedUser =this.PerformInduction.Users.find(f=>f.UserAuto==NewUserID) 
      arr.map(m => {
        if (m.UserAuto == personListItem.UserAuto) {
          m.UserAuto = selectedUser.UserAuto
          m.UserId = selectedUser.UserId
          m.UserName = selectedUser.UserName
        }
      })

      this.ArrPersonsInducted = arr;

    

  }

  AddInductionAttendeeClick(){
    const dialogRef = this.dialog.open(DialogAddAttendeeComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '1000px',
      minHeight: '500px',
      maxHeight: '600px',
      data: {
          
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("AddInductionAttendeeClick",result)
      if (result.result == true) {
        let arr = (this.ArrExternalPersonsInducted && this.ArrExternalPersonsInducted.length >0)?this.ArrExternalPersonsInducted:[];
        let _data = new UsersVM();
        _data.UserAuto = result.data.UserId
        _data.UserName = `${result.data.Fname} ${result.data.Lname}`
        _data.UserId = result.data.UserId

        arr.push(_data)

        this.ArrExternalPersonsInducted = arr
      } else if (result.result == false) {

        console.log('The dialog was closed');
      }
    });
  }

  AddFindInductionAttendeeClick(){
    const dialogRef = this.dialog.open(DialogFindAttendeeComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        ArrExternalPersonsInducted:this.ArrExternalPersonsInducted
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("AddFindInductionAttendeeClick",result)

      if (result.result == true) {
        let arr = (this.ArrExternalPersonsInducted && this.ArrExternalPersonsInducted.length >0)?this.ArrExternalPersonsInducted:[];
        result.data.map(m=>{
          let _data = new UsersVM();
          _data.UserAuto = m.UserId
          _data.UserName = `${m.Fname} ${m.Lname?m.Lname:""}`
          _data.UserId = m.UserId
  
          arr.push(_data)
        })
       

        this.ArrExternalPersonsInducted = arr
      } else if (result.result == false) {

        console.log('The dialog was closed');
      }
    });
  }

  AddButtonClicked(){
    if(this.InductionType ==1){
     // this._appService.getApplicationConfigValue("IdentityServerUri").subscribe(result => {
      //  this.identityServerUri = result;
       // window.open(this.identityServerUri+'administration/', "_blank");
       this._router.navigate(['/administrator']);
      //  this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      //   if(res=="True"){
      //     this._router.navigate(['/performinduction']);

      //   }else{             
      //     window.open(this.identityServerUri+'administrator/', "_blank");
         
      //   }
    //});
     // })
    }else if(this.InductionType > 1){

    }
    

//this.identityServerUri + 'administration/'
  }

  ClickReset(){
    let user = new UsersVM();
    user.UserAuto = -1
    let arr = []
    arr.push(user)
    this.ArrPersonsInducted = arr;
    this.State=0;

    this.InductionType=0;
    this.date = new Date();
  }

  ClickStart(){
    let params = new CreateNewInductionVM();
    let arrUserIdExternal = []
    let arrUserIdInternal = []


    if(!this.date){
      alert('Select a Date')
      return
    }

    if(this.InductionType<=0){
      alert('Select a Induction Type')
      return
    }

    if(this.State == 0){
      alert('Select a State')
      return;
    }

    if(this.InductionType >= 1 &&
      (this.ArrPersonsInducted && this.ArrPersonsInducted.length>0 && this.ArrPersonsInducted[0].UserAuto>-1) || 
      this.ArrExternalPersonsInducted && this.ArrExternalPersonsInducted.length >0){
      
      // if(this.InductionType == 1){
      //   this.ArrPersonsInducted.map(m=>{
      //     if(m.UserAuto>-1){
      //       arrUserId.push(m.UserAuto)
      //     }
      //   })
      // }else if(this.InductionType >1){
      //   this.ArrExternalPersonsInducted.map(m=>{
          
      //       arrUserId.push(m.UserAuto)
          
      //   })
      // }

      //TT-7786
      if(this.ArrPersonsInducted.length>0){
        this.ArrPersonsInducted.map(m=>{
          if(m.UserAuto>-1){
            arrUserIdInternal.push(m.UserAuto)
          }
        })
      }
      if(this.ArrExternalPersonsInducted!=null && this.ArrExternalPersonsInducted.length>0){
        this.ArrExternalPersonsInducted.map(m=>{
          
          arrUserIdExternal.push(m.UserAuto)
          
        })
      }
      
      params.InternaluserList=arrUserIdInternal

      params.ExternaluserList=arrUserIdExternal
      params.InductionDate = this.date;
      params.InductionType=this.InductionType;
      params.StateId=this.State

      this._inductionService.CreateNewInduction(params).subscribe(res=>{
        console.log("CreateNewInduction",res)
        this._router.navigate(['/startinduction', res]);
      })
    }else{
      alert("Select Persons to Induct")
    }

    
  }

}
